/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  name: z.string(),
  usage_category: z.string(),
  standard_name: z.string(),
  manufacturer: z.string(),
  package_form: z.string(),
  display_order: z.number(),
  is_active: z.boolean(),
  qr_managed: z.boolean(),
  humidity_upper: z.number().nullable(),
  humidity_lower: z.number().nullable(),
  standard_usage: z.number().nullable(),
  standard_usage_unit: z.string().nullable(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MaterialMasterBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MaterialMasterBase = z.infer<typeof base>;
export type MaterialMasterBasePutPayload = z.infer<typeof put>;
export type MaterialMasterBasePatchPayload = z.infer<typeof patch>;
export type MaterialMasterBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MaterialMasterBaseCreateAttributes = z.infer<typeof create>;
export type MaterialMasterBaseUpdateAttributes = z.infer<typeof update>;
export type MaterialMasterBaseCacheAttributes = z.infer<typeof cache>;
export type MaterialMasterBaseCachesAttributes = z.infer<typeof caches>;